import { useEffect, useState } from 'react';
import { createTypewriter } from '../lib/typewriter';

interface Props {
  text: string;
  onTick?: () => void;
  onComplete?: () => void;
}

export function TypewriterText({ text, onTick, onComplete }: Props) {
  const [displayed, setDisplayed] = useState('');

  useEffect(() => {
    const typewriter = createTypewriter({
      charsPerTick: 1,
      intervalMs: 20,
      onUpdate: (value) => {
        setDisplayed(value);
        onTick?.();
      },
      onComplete,
    });
    typewriter.push(text);
    typewriter.seal();
    return () => typewriter.cancel();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <>{displayed}</>;
}
